import { useTranslation } from 'react-i18next'

import { Check } from 'lucide-react'

import { TIPI_BUSINESS_COUNT } from '@/lib/landingStats/constants'

import { seoKeywordI18nPrefix } from './catalog'

const NEVER_USED_MGMT_SOFTWARE_PERCENT = 60

const WITHOUT_ITEMS = [1, 2, 3, 4] as const

export function AppEscandallosSocialProofSection() {
    const { t } = useTranslation()
    const prefix = seoKeywordI18nPrefix('app-escandallos')

    return (
        <section className='bg-[#17130E] px-[22px] py-14 md:px-10 md:py-20'>
            <div className='mx-auto flex w-full max-w-[720px] flex-col gap-10 md:max-w-[900px]'>
                <div className='flex flex-col gap-2.5'>
                    <div className='mb-1.5 text-xs font-semibold uppercase tracking-[2px] text-[#F4502A]'>
                        {t(`${prefix}.without.eyebrow`)}
                    </div>
                    <ul className='m-0 flex list-none flex-col gap-2.5 p-0'>
                        {WITHOUT_ITEMS.map(item => (
                            <li
                                key={item}
                                className='flex items-center gap-2.5 rounded-[14px] border border-[rgba(245,238,228,0.18)] px-4 py-3.5'
                            >
                                <Check className='size-[18px] shrink-0 text-[#F4502A]' strokeWidth={2.4} aria-hidden />
                                <span className='text-sm font-semibold text-[#F5EEE4] md:text-[15px]'>
                                    {t(`${prefix}.without.items.${item}`)}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='flex flex-col gap-2.5 border-t border-[rgba(245,238,228,0.12)] pt-8'>
                    <div className='text-xs font-semibold uppercase tracking-[2px] text-[#F4502A]'>
                        {t(`${prefix}.socialProof.eyebrow`)}
                    </div>
                    <h2 className='m-0 text-balance text-[28px] font-medium leading-[1.15] tracking-[-1px] text-[#F5EEE4] md:text-[36px]'>
                        {t(`${prefix}.socialProof.title`)}
                    </h2>
                    <p className='m-0 text-[15px] leading-[1.6] text-[#B8AFA3] md:text-base'>
                        {t(`${prefix}.socialProof.body`, {
                            count: TIPI_BUSINESS_COUNT,
                        })}
                    </p>
                </div>

                <div className='grid grid-cols-2 rounded-[20px] border border-[rgba(245,238,228,0.18)] px-5 py-7'>
                    <div className='flex flex-col gap-1 pr-4'>
                        <div className='text-[42px] font-extrabold tabular-nums leading-[0.98] tracking-[-0.035em] text-[#F5EEE4] md:text-[48px]'>
                            {TIPI_BUSINESS_COUNT}
                        </div>
                        <div className='text-[13px] leading-[1.4] text-[#B8AFA3]'>
                            {t(`${prefix}.socialProof.stat1Label`)}
                        </div>
                    </div>
                    <div className='flex flex-col gap-1 border-l border-[rgba(245,238,228,0.15)] pl-4'>
                        <div className='text-[42px] font-extrabold tabular-nums leading-[0.98] tracking-[-0.035em] text-[#1FA855] md:text-[48px]'>
                            {t(`${prefix}.socialProof.stat2Value`, {
                                percent: NEVER_USED_MGMT_SOFTWARE_PERCENT,
                            })}
                        </div>
                        <div className='text-[13px] leading-[1.4] text-[#B8AFA3]'>
                            {t(`${prefix}.socialProof.stat2Label`)}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
